/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_5_TInputs */

const en_cp_cal_5_t = /** @type {(inputs: Cp_Cal_5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint 3 — validation`)
};

const id_cp_cal_5_t = /** @type {(inputs: Cp_Cal_5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint 3 — validasi`)
};

/**
* | output |
* | --- |
* | "Sprint 3 — validation" |
*
* @param {Cp_Cal_5_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_5_t = /** @type {((inputs?: Cp_Cal_5_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_5_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_5_t(inputs)
	return en_cp_cal_5_t(inputs)
});